<template>
  <section v-bind="$attrs" class="company-culture">
    <navigation-sub
      :list="[
        {
          title: $t('mission.title')
        },
        {
          title: $t('goal.title')
        },
        {
          title: $t('servicePrinciples.title')
        },
        {
          title: $t('principles.title')
        }
      ]"
    />

    <div class="company-title-wrap">
      <h4 class="company-title">{{ $t('menuCompany.woowaCulture') }}</h4>
    </div>

    <!-- 우아한 미션 -->
    <article
      :id="hashTitle($t('mission.title'))"
      ref="mission"
      class="article-anchor company-box"
    >
      <div class="company-box-image">
        <p>
          <picture>
            <source media="(min-width: 750px)" srcset="~@/static/image/company/pc/image_vision_3.png">
            <source media="(max-width: 750px)" srcset="~@/static/image/company/pc/image_vision_3.png">
            <img src="~@/static/image/company/pc/image_vision_3.png" :alt="$t('principles.name')">
          </picture>
        </p>
      </div>
      <html-view :value="$t('mission.title')" class="company-box-title" />
      <html-view :value="$t('mission.content')" class="company-box-content" />
    </article>

    <!-- Goal -->
    <article
      :id="hashTitle($t('goal.title'))"
      ref="goal"
      class="article-anchor company-box company-goal"
    >
      <div class="company-box-title">{{ $t('goal.title') }}</div>
      <div class="company-box-content">
        <strong>{{ $t('goal.content') }}</strong>
      </div>
    </article>

    <!-- 서비스 원칙 -->
    <article
      :id="hashTitle($t('servicePrinciples.title'))"
      ref="servicePrinciples"
      class="article-anchor company-box"
    >
      <div class="company-box-image company-box-image-culture">
        <picture>
          <source media="(min-width: 980px)" srcset="~@/static/image/company/pc/culture-2.jpg">
          <source media="(max-width: 980px)" srcset="~@/static/image/company/m/culture-2.jpg">
          <img src="~@/static/image/company/pc/culture-2.jpg" :alt="$t('company.head')">
        </picture>
      </div>
      <div class="company-box-title">{{ $t('servicePrinciples.title') }}</div>
      <div class="company-box-content">
        <p class="emphasis">{{ $t('servicePrinciples.desc') }}</p>
        <ol class="list-number">
          <li
            v-for="(item, index) in $t('servicePrinciples.list')"
            :key="`service-principles-${index}`"
            class="list-number-item"
          >
            <p class="list-number-heading">
              <i class="number" />
              <html-view tag="span" :value="$t(item.title)" />
            </p>
            <html-view :value="$t(item.desc)" class="list-number-content" />
          </li>
        </ol>
      </div>
    </article>

    <!-- 우아한 일원칙 -->
    <article
      :id="hashTitle($t('principles.title'))"
      ref="principle"
      class="article-anchor company-box company-principle"
    >
      <html-view :value="$t('principles.title')" class="company-box-title" />
      <html-view :value="$t('principles.content')" class="company-box-content" />
      <div class="company-box-image">
        <p>
          <img src="~@/static/image/company/principle_2.jpg" :alt="$t('principles.name')">
        </p>
      </div>
      <div class="company-box-title" />
      <div class="company-box-content principle-box-wrap">
        <div v-for="(item, index) in $t('principles.group')" :key="`principles-group-${index}`" class="principle-box">
          <html-view :value="$t(item.title)" class="principle-box-title" />
          <html-view :value="$t(item.desc)" class="principle-box-desc" />
          <ul class="principle-list">
            <li v-for="(list, key) in item.list" :key="`group-${index}-list-${key}`">
              <div class="principle-list-title">{{ $t(list.title) }}</div>
              <div>{{ $t(list.content) }}</div>
            </li>
          </ul>
        </div>
      </div>
    </article>
  </section>
</template>
<script>
import gtag from '@/mixins/gtag'
import isKorean from '@/mixins/isKorean'
import { hashTitle } from '@/util'

export default {
  components: {
    navigationSub: () => import('@/components/base/NavigationSub'),
  },
  mixins: [gtag, isKorean],
  data () {
    return {
      sections: [
        'mission',
        'servicePrinciples',
        'principles'
      ]
    }
  },
  mounted () {
    this.$nextTick(this.init)
  },
  methods: {
    hashTitle,
    init () {
      this.sections.forEach(section => {
        if (this.$refs[section]) {
          this.initGtag({
            element: this.$refs[section],
            isView: true,
            ga: {
              name: '회사소개_우아한 문화',
              category: '회사소개_우아한 문화',
              label: this.$t(`${section}.title`),
              page: '회사소개'
            }
          })
        }
      })
    },
  }
}
</script>
